<template>
    <th colspan="1" rowspan="1" @click="sortValue">
        <div class="vs-table-text">
            <slot></slot>
            <span v-if="isColumnSelectedForSort && currentSortType" class="sort-th">
                <vs-icon
                    :icon="currentSortType == 1 ? 'expand_less' : 'expand_more'"
                    class="th-sort-icon"
                />
            </span>
        </div>
    </th>
</template>

<script>
import { findClosestParent } from '../../../assets/utils/components'

export default {
    name: 'vx-th',
    props: {
        sortKey: {
            default: null,
            type: String
        }
    },
    watch: {
        isColumnSelectedForSort(v) {
            if (!v) {
                this.resetSort()
            }
        }
    },
    data: () => ({
        thIndex: 0,
        thwidth: '100%',
        currentSortType: 0,
        sortTypes: [null, 'asc', 'desc']
    }),
    computed: {
        styleth() {
            return {
                width: this.thwidth
            }
        },
        isColumnSelectedForSort() {
            if (!this.sortKey || this.parentSortKey != this.sortKey) {
                return false
            }
            return true
        },
        parentSortKey() {
            return this.parent.currentSortKey
        },
        parent() {
            return findClosestParent(this, 'vx-table')
        }
    },
    methods: {
        sortValue() {
            if (!this.sortKey) {
                return
            }
            this.currentSortType = (this.currentSortType + 1) % 3
            this.parent.localSortParams = {
                // if sorting is disabled, we don't want to send any sort params
                sortKey: this.currentSortType ? this.sortKey : null,
                sortType: this.sortTypes[this.currentSortType]
            }
        },
        resetSort() {
            this.currentSortType = 0
        }
    }
}
</script>
